import { PageType } from '../../../api/models/Shared.types';
import { SearchPage } from '../../content/searchpage/SearchPage';
import { CmsPage } from '../../content/CmsPage';
import { EpgListPage } from '../../content/listPage/EpgListPage';
import { SettingsPage } from '../../settings/SettingsPage';
import { RecordingPage } from '../../content/recording/RecordingPage';
import { EpgGuidePage } from '../../content/guide/EpgGuidePage';
import { EmptyPage } from '../../EmptyPage';
import { ReminderPage } from '../../content/reminders/ReminderPage';

export class PageDetector {
  /**
   *
   * @param {IMenuItem} item
   * @return Page Class
   * @return {DetailPage|CmsPage|null|SearchPage|TestCmsPage|LoginPage}
   */
  static forItem(item) {
    switch (item.pageType) {
      case PageType.Search:
        return SearchPage;
      case PageType.Cms:
        return CmsPage;
      case PageType.List:
        return EpgListPage;
      case PageType.Guide:
        return EpgGuidePage;
      case PageType.Settings:
        return SettingsPage;
      case PageType.RecordingRecorded:
      case PageType.RecordingPlanned:
      case PageType.RecordingExpired:
        return RecordingPage;
      case PageType.Reminders:
        return ReminderPage;
      case PageType.ClientArea:
      case PageType.RecordingConflict:
      case PageType.SubscriptionAvailable:
      case PageType.SubscriptionActive:
      case PageType.MessageInbox:
      case PageType.Apps:
      default:
        return EmptyPage;
    }
  }
}
